import { render } from "./StartupDetails.vue?vue&type=template&id=1607c4ea"
import script from "./StartupDetails.vue?vue&type=script&lang=js"
export * from "./StartupDetails.vue?vue&type=script&lang=js"
script.render = render

export default script